import React from "react";
import { useDispatch } from "react-redux";
import {
  decrementProductQuantity,
  deleteproductfromcart,
  incrementProductQuantity,
} from "../redux/product/actions";

export default function CartCard({ cart_product }) {
  const dispatch = useDispatch();
  const { product_id, title, category, price, url, quantity } =
    cart_product || {};

  function incrementQuantity(product_id) {
    dispatch(incrementProductQuantity(product_id));
  }

  function decrementQuantity(product_id) {
    dispatch(decrementProductQuantity(product_id));
  }

  function removeFromCart(product_id) {
    dispatch(deleteproductfromcart(product_id));
  }

  return (
    <div className="cartCard">
      <div className="flex items-center col-span-6 space-x-6">
        <img className="lws-cartImage" src={url} alt="product" />

        <div className="space-y-2">
          <h4 className="lws-cartName">{title}</h4>
          <p className="lws-cartCategory">{category}</p>
          <p>
            BDT <span className="lws-cartPrice">{price}</span>
          </p>
        </div>
      </div>
      <div className="flex items-center justify-center col-span-4 mt-4 space-x-8 md:mt-0">
        <div className="flex items-center space-x-4">
          <button
            onClick={() => incrementQuantity(product_id)}
            className="lws-incrementQuantity"
          >
            <i className="text-lg fa-solid fa-plus"></i>
          </button>
          <span className="lws-cartQuantity">{quantity}</span>
          <button
            onClick={() => decrementQuantity(product_id)}
            className="lws-decrementQuantity"
          >
            <i className="text-lg fa-solid fa-minus"></i>
          </button>
        </div>

        <p className="text-lg font-bold">
          BDT <span className="lws-calculatedPrice">{quantity * price}</span>
        </p>
      </div>

      <div className="flex items-center justify-center col-span-2 mt-4 md:justify-end md:mt-0">
        <button
          onClick={() => removeFromCart(product_id)}
          className="lws-removeFromCart"
        >
          <i className="text-lg text-red-400 fa-solid fa-trash"></i>
        </button>
      </div>
    </div>
  );
}
